import {

    useEffect,
    useState,
    useCallback

} from "react";
import { followupsApi } from "../services";
import { toastSuccess } from "../../../common/utils/toast";



export default function useFollowups(

    leadId

){

    const [

        loading,

        setLoading

    ]=useState(true);

    const [

        followups,

        setFollowups

    ]=useState([]);

    const refresh=

    useCallback(

        async()=>{

            if(!leadId){

                return;

            }

            try{

                setLoading(true);

                const{

                    data

                }=

                await followupsApi

                .getLeadFollowups(

                    leadId

                );

                setFollowups(

                    data.data||

                    data

                );

            }

            finally{

                setLoading(false);

            }

        },

        [

            leadId

        ]

    );

    useEffect(()=>{

        refresh();

    },[refresh]);

    async function createFollowup(payload){

        await followupsApi.createFollowup(

            leadId,

            payload

        );

        toastSuccess(

            "Follow-up scheduled"

        );

        refresh();

    }

    async function completeFollowup(id){

        await followupsApi.completeFollowup(id);

        toastSuccess(

            "Follow-up completed"

        );

        refresh();

    }

    async function deleteFollowup(id){

        await followupsApi.deleteFollowup(id);

        toastSuccess(

            "Follow-up deleted"

        );

        refresh();

    }

    return{

        loading,

        followups,

        refresh,

        createFollowup,

        completeFollowup,

        deleteFollowup

    };

}